module.exports = __webpack_public_path__ + "img/icon-globe.42d18fc2.svg";